import EmphasizedContent from '@blocks/EmphasizedContent'
import Grid from '@blocks/Grid'
import React from 'react'
import { useVotingDashboardContext } from '../context'

export default function VotingJuries() {
    const { voting } = useVotingDashboardContext()

    return (
        <Grid gap="15px">
            <Grid gap="0px">
                <small>Juries</small>
                <hr />
            </Grid>
            <Grid columns="3">
                {voting.data.juries.map(jury => (
                    <EmphasizedContent key={jury.id}>
                        <Grid gap="5px">
                            <h4>{jury.first_name} {jury.last_name}</h4>
                            <p>Votes: {jury.votes_count} / {jury.responsible_count}</p>
                        </Grid>
                    </EmphasizedContent>
                ))}
            </Grid>
        </Grid>
    )
}